import { actionCreatorFactory } from '../../core/utils/factories';
import {
  AssociatedProject,
  ContactsData,
  CreateSiteResp,
  OptionProps,
  PaginatedResponse,
  SiteAssociatedProjectsTabData,
  SiteBrowse,
  SiteContactsTabData,
  SiteInformationTabData,
} from '../../models/interfaces';

const actionCreator = actionCreatorFactory('SITE');

export namespace SiteActions {
  export const getSiteBrowseDataAction =
    actionCreator.createAsyncAction<PaginatedResponse<SiteBrowse>>(
      'GET_BROWSE_DATA',
    );
  export const getAssociatedProjectsDataAction =
    actionCreator.createAsyncAction<AssociatedProject[]>(
      'GET_ASSOCIATED_PROJECTS_DATA',
    );
  export const createSiteAction =
    actionCreator.createAsyncAction<CreateSiteResp>('CREATE_SITE');
  export const updateSiteAction =
    actionCreator.createAsyncAction<SiteBrowse>('UPDATE_SITE');
  export const getSiteInformationAction =
    actionCreator.createAsyncAction<SiteInformationTabData>(
      'GET_SITE_INFORMATION',
    );
  export const getSiteContactsAction =
    actionCreator.createAsyncAction<SiteContactsTabData>('GET_SITE_CONTACTS');
  export const getSiteAssociatedProjectsAction =
    actionCreator.createAsyncAction<SiteAssociatedProjectsTabData>(
      'GET_SITE_ASSOCIATED_PROJECTS',
    );
  export const setTabLoading = actionCreator.createAsyncAction<{
    tabName: string;
    isLoading: boolean;
  }>('SET_TAB_LOADING');
  export const setTabLoaded = actionCreator.createAsyncAction<{
    tabName: string;
    isLoaded: boolean;
  }>('SET_TAB_LOADED');
  export const setTabError = actionCreator.createAsyncAction<{
    tabName: string;
    hasError: boolean;
  }>('SET_TAB_ERROR');
  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');
  export const createSiteContactAction =
    actionCreator.createAsyncAction<ContactsData>('CREATE_SITE_CONTACT');
  export const updateSiteContactAction =
    actionCreator.createAsyncAction<ContactsData>('UPDATE_SITE_CONTACT');
  export const deleteSiteContactAction =
    actionCreator.createAsyncAction<string>('DELETE_SITE_CONTACT');
  export const clearCreatedSite =
    actionCreator.createAsyncAction<void>('CLEAR_CURRENT_SITE');
  export const getPSLocationCodeOptionsList = actionCreator.createAsyncAction<
    OptionProps[]
  >('GET_PS_LOCATION_NUMBER_OPTIONS');
  export const getMDGLocationCodeOptionsList = actionCreator.createAsyncAction<
    OptionProps[]
  >('GET_MDG_LOCATION_NUMBER_OPTIONS');
}
